import { FlatList } from 'react-native';
import type { PlayerSquareProps, SquareOfferProps, SquareProps, SquareValueProps } from '../../types';
import { Icons } from '../../Components';
import React, { useState } from 'react';
import Colors from '../../constants/colors';
import { SquaresApi } from '../api';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type MySquaresCardProps = {
    player_squares:PlayerSquareProps[],
    squares:SquareProps[],
    hidden?:boolean,
    disable_collapse?:boolean,
    square_offers:SquareOfferProps[],
    away_abbr?:string,
    home_abbr?:string,
    my_square_values:SquareValueProps[],
    comp_status: string,
    onSquareOffer: (square:SquareProps, action:'add'|'remove') => void
}

const MySquaresCard = ({ hidden, disable_collapse, player_squares, squares, away_abbr, home_abbr, square_offers, my_square_values, comp_status, onSquareOffer }: MySquaresCardProps) => {
    const C = useColors();
    const [ expanded, setExpanded ] = useState(true);
    const renderPlayerSquares = (data: { item:SquareValueProps, index: number }) => {
        const player_square = player_squares.find(ps => ps.sq_square_id == data.item.sq_square_id);
        const square = squares.find(s => s.sq_square_id == data.item.sq_square_id);
        if(!square || !player_square){ return <></> }
        const square_offer = square_offers.find(so => so.sq_player_square_id == player_square.sq_player_square_id && so.status == 'offered');
        const square_value = my_square_values.find(sv => sv.sq_square_id == player_square.sq_square_id);
        return (
            <View transparent type='row' style={{ padding:5, borderBottomWidth:1, borderColor:C.borders.light }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h2'>SQUARE: {home_abbr}: {square.square_score_x}, {away_abbr}: {square.square_score_y}</Text>
                    <Text style={{ marginTop:3 }} theme='description'>${player_square.purchase_price.toFixed(2)}</Text>
                </View>
                {square_value ?
                <View transparent style={{ paddingRight:20, paddingLeft:20 }}>
                    <Text size={14} weight='bold' color={square_value.expected_value > 0 ? C.text.success : C.text.error}>EV ${square_value.expected_payout.toFixed(2)}</Text>
                </View>
                :<></>}
                {comp_status == 'in_progress' ?
                <View transparent>
                    {square_offer ?
                    <Button
                        title='WITHDRAW'
                        title_color={Colors.shades.white}
                        backgroundColor={Colors.utility.warning}
                        onPress={async() => await SquaresApi.offserSquare({ ...square_offer, status: 'withdrawn' })}
                    />
                    :
                    <Button
                        title='SELL'
                        title_color={C.text.white}
                        backgroundColor={C.text.action}
                        onPress={() => onSquareOffer(square, 'add')}
                    />
                    }
                </View>
                :<></>}
            </View>
        )
    }

    if(hidden){ return <></> }
    return (
        <View float style={{ minWidth:350, borderRadius:0 }}>
            <Button disabled={disable_collapse} transparent style={{ flexDirection:'row', alignItems:'center' }} onPress={() => setExpanded(!expanded)}>
                <View transparent style={{ height:18, width:18, borderRadius:100, backgroundColor:Colors.highlights.highlight200, justifyContent:'center', alignItems:'center' }}>
                    <Text size={10} weight='bold' color={Colors.shades.white} textAlign='center'>{player_squares.length}</Text>
                </View>
                <View transparent style={{flex:1, marginLeft:10}}>
                    <Text theme='h1'>MY SQUARES</Text>
                    <Text style={{ marginTop:3 }} theme='description'>Square you either own or have the highest bid on</Text>
                </View>
                {!disable_collapse ?
                <Icons.ChevronIcon direction={expanded?'up':'down'} size={8} color={C.text.h1}/>
                :<></>}
            </Button>
            {expanded ? 
            <View transparent style={{ padding:20 }}>
                <FlatList
                    data={my_square_values.filter(sv => player_squares.map(ps => ps.sq_square_id.toString()).includes(sv.sq_square_id.toString())).sort((a,b) => b.expected_value - a.expected_value)}
                    renderItem={renderPlayerSquares}
                    keyExtractor={(item) => item.sq_square_id.toString()}
                />
            </View>
            :<></>}
        </View>
    )
}

export default MySquaresCard